import { render } from "./CPOReservations.vue?vue&type=template&id=134aca30&scoped=true"
import script from "./CPOReservations.vue?vue&type=script&lang=js"
export * from "./CPOReservations.vue?vue&type=script&lang=js"

import "./CPOReservations.vue?vue&type=style&index=0&id=134aca30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134aca30"]])

export default __exports__